import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import ContentBox from 'components/ContentBox'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import ButtonPrimary from 'components/ButtonPrimary'
import Video from 'components/Video'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'

const messages = defineMessages({
  referenceVideo: {
    id: 'ReferenceVideoSection.referenceVideo',
    defaultMessage: 'Reference Video'
  },
  removeReference: {
    id: 'ReferenceVideoSection.removeReference',
    defaultMessage: 'Remove Reference Video'
  }
})

export const ReferenceVideoSection = ({
  videoUrl,
  posterUrl,
  onRemove
}) => {
  const intl = useIntl()

  if (!videoUrl || !posterUrl) {
    return null
  }

  return (
    <ContentBox mb={4}>
      <View
        row
        style={{
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        mb={2}
      >
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.referenceVideo)}
        </TextTitleCompressedHeavy>
        <ButtonPrimary onClick={onRemove}>
          {formatMessageIntlUtil(intl, messages.removeReference)}
        </ButtonPrimary>
      </View>
      <Video
        source={videoUrl}
        poster={posterUrl}
        key={videoUrl}
        width='100%'
      />
    </ContentBox>
  )
}

ReferenceVideoSection.propTypes = {
  videoUrl: PropTypes.string,
  posterUrl: PropTypes.string,
  onRemove: PropTypes.func.isRequired
}
